import { useEffect } from 'react'

const events = ['click']

export default function useClickOutside(ref, handler) {
  useEffect(() => {
    if (!handler) return

    const listener = event => {
      if (
        ref.current &&
        // not inside
        !ref.current.contains(event.target) &&
        // inside #root - not a portal
        document.getElementById('root').contains(event.target)
      )
        handler(event)
    }

    events.forEach(event => {
      document.addEventListener(event, listener)
    })

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, listener)
      })
    }
  }, [handler, ref.current])
}
